export default __webpack_public_path__ + "static/media/NZFSSRC_logo.791ca915.png";